import React from 'react';
import { motion } from 'framer-motion';
import { Play, Trophy } from 'lucide-react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
export function TestimonialSection() {
  const {
    ref,
    isVisible
  } = useScrollAnimation(0.1);
  return <section className="py-24 relative overflow-hidden" data-id="element-246">
      {/* Ambient Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-purple-600/20 blur-[100px] rounded-full pointer-events-none" data-id="element-247" />

      <div className="container mx-auto px-4 max-w-4xl relative z-10 text-center" data-id="element-248">
        <motion.div ref={ref} initial={{
        opacity: 0,
        y: 20
      }} animate={isVisible ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} data-id="element-249">
          <div className="inline-flex items-center gap-2 bg-yellow-500/10 border border-yellow-500/20 text-yellow-400 px-4 py-2 rounded-full text-sm font-bold mb-6" data-id="element-250">
            <Trophy className="w-4 h-4" data-id="element-251" />
            <span data-id="element-252">Caso de Éxito Destacado</span>
          </div>

          <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-253">
            "La herramienta secreta detrás de Launch Expert"
          </h2>
          <p className="text-xl text-gray-400 mb-12 max-w-2xl mx-auto" data-id="element-254">
            Santiago Bilbao (Founder) explica cómo +90 alumnos generaron miles
            de dólares usando estos mismos creativos.
          </p>

          {/* Vertical Video - Wistia Embed */}
          <div className="relative mx-auto w-[300px] md:w-[360px] aspect-[9/16] bg-black rounded-3xl border border-white/10 shadow-[0_20px_80px_rgba(0,0,0,0.5)] overflow-hidden" data-id="element-255">
            <iframe src="https://fast.wistia.net/embed/iframe/w7eb1734dg?web_component=true&seo=false" title="Caso de éxito Santiago Bilbao" allow="autoplay; fullscreen" allowTransparency={true} frameBorder="0" scrolling="no" className="absolute inset-0 w-full h-full" data-id="element-256" />
          </div>

          {/* Quotes */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-16" data-id="element-257">
            {[{
            quote: 'Pasé de 5 creativos por semana a 100 en un día',
            author: 'Media Buyer'
          }, {
            quote: 'Mi ROAS subió 3x en el primer mes',
            author: 'Agencia de IA'
          }, {
            quote: 'Ya no necesito diseñador para mis campañas',
            author: 'Infoproductor'
          }].map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} animate={isVisible ? {
            opacity: 1,
            y: 0
          } : {}} transition={{
            delay: 0.4 + i * 0.1,
            duration: 0.5
          }} className="bg-white/5 border border-white/5 p-6 rounded-xl text-left" data-id="element-258">
                <p className="text-gray-300 italic mb-4" data-id="element-259">"{item.quote}"</p>
                <p className="text-sm font-bold text-purple-400" data-id="element-260">
                  - {item.author}
                </p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}